import React, { useState } from 'react';

import { translateComponent } from '@/utils/tolgee/translateComponent';
import {
  LomavisPostCard2,
  PostData
} from '@/lomavisSharedUi/atoms/cards/LomavisPostCard2';
import { Button, Modal } from 'react-bootstrap';
import { LomavisPostCardDetails1 } from '@/lomavisSharedUi/atoms/cards/LomavisPostCardDetails1';

interface LomavisPostCardList1Props {
  /** The text to display inside the H1 heading */
  title?: string;
  data: PostData[];
}

interface ModalProps {
  /** The text to display inside the H1 heading */
  show: boolean;
  data: PostData;
  onClose: () => void;
  next: () => void;
  prev: () => void;
}

const DetailsModal: React.FC<ModalProps> = ({
  data,
  show,
  onClose,
  next,
  prev
}) => {
  return (
    <Modal
      show={show}
      size="xl"
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body
        style={{ minHeight: '500px', maxHeight: '600px', overflowY: 'auto' }}
        className=""
      >
        <LomavisPostCardDetails1 data={data} />
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex gap-3 me-4">
          <span onClick={() => prev()} className="p-2 cursor-pointer">
            <i className="fa-regular fa-chevron-left fs-1"></i>
          </span>
          <span onClick={() => next()} className="p-2 cursor-pointer">
            <i className="fa-regular fa-chevron-right fs-1"></i>
          </span>
        </div>

        <Button onClick={onClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

/**
 * Organisms: LomavisPostCardList1
 */
export const LomavisPostCardList1: React.FC<LomavisPostCardList1Props> = ({
  title,
  data
}) => {
  const t = translateComponent('LomavisPostCardList1');

  const [currentIndex, setCurrentIndex] = useState(0);
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <div className="w-100 h-100">
      <DetailsModal
        show={modalShow}
        onClose={() => setModalShow(false)}
        data={data[currentIndex]}
        next={
          currentIndex < data?.length - 1
            ? () => setCurrentIndex(currentIndex + 1)
            : () => {}
        }
        prev={
          currentIndex !== 0
            ? () => setCurrentIndex(currentIndex - 1)
            : () => {}
        }
      />
      {title && t('TOLGEE_EXMAPLE_KEY_REPLACE_ME')}
      <div className="w-100 row g-3 justify-content-start">
        {data?.map((item, index) => (
          <div
            onClick={() => {
              setCurrentIndex(index);
              setModalShow(true);
            }}
            key={index}
            className="col-12 col-md-6 col-lg-4 cursor-pointer"
            style={{ minHeight: '400px' }}
          >
            <LomavisPostCard2 data={item} />
          </div>
        ))}
      </div>
    </div>
  );
};
